import React, { useState } from "react";
import { Button, message } from "antd";
import axiosInstance from "../../../../services/server/axios";
import { useTranslation } from "react-i18next"; // ✅ import hook

const SecuritySettings = () => {
  const { t } = useTranslation(); // ✅ initialize
  const [form, setForm] = useState({
    current_password: "",
    new_password: "",
    new_password_confirmation: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setForm({ ...form, [e.target.id]: e.target.value });
  };

  const handleSubmit = async () => {
    setErrors({});
    const token = localStorage.getItem("authToken");

    try {
      await axiosInstance.put(
        "/change-password",
        form,
        {
          headers: { // ✅ fix headers placement
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      message.success(t("password_updated_successfully")); // ✅ translated message
      setForm({ current_password: "", new_password: "", new_password_confirmation: "" });
    } catch (err) {
      if (err.response?.status === 422) {
        setErrors(err.response.data.errors || { general: err.response.data.message });
      } else {
        message.error(t("something_went_wrong")); // ✅ translated message
      }
    }
  };

  return (
    <div className="p-1">
      <div style={{ maxWidth: "672px" }}>
        <h1 className="h2 fw-bold mb-5" style={{ color: "var(--primary-color3)" }}>
          {t("security_settings")}
        </h1>

        {/* Password Section */}
        <div className="card rounded-3 p-4 mb-5" style={{ background: "var(--primary-color8)" }}>
          <h2 className="h4 fw-semibold mb-4" style={{ color: "var(--primary-color3)" }}>
            {t("change_password")}
          </h2>

          <div className="row g-4">
            {/* Current Password */}
            <div className="col-12">
              <label htmlFor="current_password" className="form-label" style={{ color: "var(--primary-color3)" }}>
                {t("current_password")}
              </label>
              <input
                id="current_password"
                type="password"
                placeholder={t("enter_current_password")}
                className={`form-control ${errors.current_password || errors.general ? "is-invalid" : ""}`}
                value={form.current_password}
                onChange={handleChange}
              />
              {errors.current_password && <div className="invalid-feedback">{errors.current_password[0]}</div>}
              {errors.general && <div className="invalid-feedback">{errors.general}</div>}
            </div>

            {/* New Password */}
            <div className="col-12">
              <label htmlFor="new_password" className="form-label" style={{ color: "var(--primary-color3)" }}>
                {t("new_password")}
              </label>
              <input
                id="new_password"
                type="password"
                placeholder={t("enter_new_password")}
                className={`form-control ${errors.new_password ? "is-invalid" : ""}`}
                value={form.new_password}
                onChange={handleChange}
              />
              {errors.new_password && <div className="invalid-feedback">{errors.new_password[0]}</div>}
            </div>

            {/* Confirm New Password */}
            <div className="col-12">
              <label htmlFor="new_password_confirmation" className="form-label" style={{ color: "var(--primary-color3)" }}>
                {t("confirm_new_password")}
              </label>
              <input
                id="new_password_confirmation"
                type="password"
                placeholder={t("confirm_new_password_placeholder")}
                className={`form-control ${errors.new_password_confirmation ? "is-invalid" : ""}`}
                value={form.new_password_confirmation}
                onChange={handleChange}
              />
              {errors.new_password_confirmation && (
                <div className="invalid-feedback">{errors.new_password_confirmation[0]}</div>
              )}
            </div>

            {/* Button */}
            <div className="col-12">
              <Button type="primary" style={{ color: "var(--primary-color3)" }} onClick={handleSubmit}>
                {t("update_password")}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecuritySettings;
